import { createFromJS } from "../types";
import activeTutorialPath from "./activeTutorialPath";
import appState from "./appState";
import autoUpdates from "./autoUpdates";
import chainReducer from "./chainReducer";
import characterWidthMap from "./characterWidthMap";
import combineReducersWithGlobal from "./combineReducersWithGlobal";
import definitions from "./definition";
import filters from "./filters";
import mobileScreen from "./mobileScreen";
import preferences from "./preferences";
import printOptions from "./printOptions";
import registration from "./registration";
import uiState from "./uiState";
import welcome from "./welcome";

const data = combineReducersWithGlobal(createFromJS.TimelineDataRecord({}), {
  filters
});

export const timelineReducer = combineReducersWithGlobal(createFromJS.TimelineRecord({}), {
  definitions,
  data,
  appState,
  uiState,
  welcome,
  preferences,
  autoUpdates,
  characterWidthMap,
  mobileScreen,
  printOptions,
  activeTutorialPath,
  registration
});

// Respond to the BATCH command to chain multiple reducers together in a single
// action.
export const chainedReducer = chainReducer(timelineReducer);
